import React from 'react';
import './EmployeeTable.css';


const EmployeeTable = ({ employees, onEdit, onDelete }) => {
     // Helper to map API fields to table columns
     const renderRows = employees.map((employee) => (
          <tr key={employee.emp_id}>
               <td>{employee.employee_code}</td>
               <td>{employee.employee_name}</td>
               <td>{employee.email}</td>
               <td>{employee.emp_type}</td>
               <td>{employee.department}</td>
               <td>{employee.position || employee.designation || employee.designation_name}</td>
               <td>
                    <span className={`status-badge ${employee.separation_status ? employee.separation_status.toLowerCase() : ''}`}>
                         {employee.separation_status || employee.status}
                    </span>
               </td>
               <td>
                    <button className="action-button edit" onClick={() => onEdit && onEdit(employee)}>Edit</button>
                    <button
                         className="action-button delete"
                         onClick={() => onDelete && onDelete(employee)}
                    >
                         Delete
                    </button>
               </td>
          </tr>
     ));

     return (
          <div className="employee-table-container">
               <table className="employee-table">
                    <thead>
                         <tr>
                              <th>EmpCode</th>
                              <th>Name</th>
                              <th>Email</th>
                              <th>Type</th>
                              <th>Department</th>
                              <th>Position</th>
                              <th>Status</th>
                              <th>Actions</th>
                         </tr>
                    </thead>
                    <tbody>
                         {renderRows}
                    </tbody>
               </table>
          </div>
     );
};

export default EmployeeTable;